import React from "react";
import halfPage from "../assets/images/halfPage.svg";
import { useSelector } from "react-redux";
import ellipse from "../assets/images/Ellipse.svg";
function HalfPageDesign(props) {
  const { gradientColor } = useSelector((state) => state.theme);
  const themeImage = window.sessionStorage.getItem("theme_landing_image");
  return (
    <div
      className="container-fluid"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <div>
        <img
          src={ellipse}
          style={{ position: "absolute", top: "0px", right: "0px" }}
        />
        <img
          src={ellipse}
          style={{
            position: "absolute",
            top: "54px",
            right: "-127px",
            transform: "rotate(90deg)",
          }}
        />
      </div>
      <div
        className="row"
        style={{ padding: "0px" }}
      >
        <div
          className="col-md-6 d-sm-none d-none d-md-block d-lg-block"
          style={{
            background: `linear-gradient(${gradientColor.color1}, ${gradientColor.color2})`,
            height: "100vh",
            overflow: "hidden",
            padding: "0px",
          }}
        >
          {themeImage && (
            <img
              src={themeImage}
              className="w-100"
              style={{ objectFit: "cover", height: "100%" }}
            />
          )}
        </div>
        <div
          className="col-md-6 p-5"
          style={{ height: "100vh", overflow: "auto" }}
        >
          {props.innerDesign}
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <img
          src={ellipse}
          style={{
            position: "absolute",
            bottom: "0px",
            right: "0px",
            transform: "rotate(180deg)",
          }}
        />
        <img
          src={ellipse}
          style={{
            position: "absolute",
            bottom: "70px",
            right: "-127px",
            transform: "rotate(90deg)",
          }}
        />
      </div>
    </div>
  );
}
export default HalfPageDesign;
